import _ from 'lodash'

const isAdvertisementLoading = (state) => _.get(state, 'isLoading')
const banner = (state) => _.get(state, 'banner')
const isPostModalShow = (state) => _.get(state, 'isPostModalShow')
const isDeleteModalShow = (state) => _.get(state, 'isDeleteModalShow')
const isMyPost = (state) => _.get(state, 'isMyPost')
const isTypePost = (state) => _.get(state, 'isTypePost')

export default {
	isAdvertisementLoading,
	banner,
	isPostModalShow,
	isDeleteModalShow,
	isMyPost,
	isTypePost,
}
